/**
 * Manufacturer Settings frontend feature registration (US-MFR-00).
 *
 * One nav entry + the module route, gated by `manufacturers:settings:read`.
 */
import React, { lazy } from 'react'
import { Route } from 'react-router-dom'
import { Factory } from 'lucide-react'
import { ProtectedRoute } from '@/components/ProtectedRoute'
import { lazyRoute } from '../routeHelpers'
import type { FrontendFeature } from '../types'

const ManufacturerSettingsPage = lazy(() => import('./pages/ManufacturerSettingsPage'))

const feature: FrontendFeature = {
  navItems: [
    {
      path: '/manufacturer-settings',
      label: 'Manufacturers',
      icon: Factory,
      requiredPermissions: ['manufacturers:settings:read'],
    },
  ],
  routes: [
    <Route
      key="mfr-settings"
      path="/manufacturer-settings"
      element={
        <ProtectedRoute requiredPermissions={['manufacturers:settings:read']}>
          {lazyRoute(<ManufacturerSettingsPage />)}
        </ProtectedRoute>
      }
    />,
  ],
}

export default feature
